<template>
  <div class="limit-popup">
    <div class="modal-status">Attention</div>
    <div class="modal-popup">
      {{ $t('message.sync.limit') }}
    </div>
    <div class="modal-status">
      {{ $t('message.sync.popOut') }}
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
</style>
